/**
 * @file index.tsx
 *
 * @fileoverview Renders button for sharing on Xing.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import XingColorIcon from '~/vcl/icons/color/Xing';
import { FormattedMessage } from 'react-intl';
import XingIcon from '~/vcl/icons/Xing';

export default function XingSharingButton({
  url,
  coloredIcons = true,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_xing"
          defaultMessage="on Xing"
        />
      }
      urlToShare={url}
      href="https://www.xing.com/spi/shares/new?url="
      IconComponent={coloredIcons ? XingColorIcon : XingIcon}
      {...props}
    />
  );
}
export { XingSharingButton };
